<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="py-6">Xác nhận sửa chuyên cần</v-card-title>
        <v-card-text style="color: black">
          Xác nhận đổi chuyên cần từ <strong>{{ oldStatus | getStatus }}</strong> sang
          <strong>{{ newStatus | getStatus }}</strong
          >. Xác nhận đổi?
        </v-card-text>
        <v-card-actions class="px-6 pb-6 pt-0">
          <v-btn color="blue darken-4" text @click="close" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="messageConfirm" persistent max-width="420px">
      <v-card>
        <v-card-title class="py-6">Xác nhận sửa chuyên cần</v-card-title>
        <v-card-text style="color: black">
          Thay đổi chuyên cần từ <strong>{{ oldStatus | getStatus }}</strong> sang
          <strong>{{ newStatus | getStatus }}</strong> sẽ gửi tin nhắn và thông báo để nhắc nhờ phụ huynh và học sinh
          quẹt thẻ. Xác nhận đổi?
        </v-card-text>
        <v-card-actions class="px-6 pb-6 pt-0">
          <v-btn color="blue darken-4" text @click="closeConfirm" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      dialog: false,
      messageConfirm: false,
    }
  },
  props: {
    state: Boolean,
    oldStatus: String,
    newStatus: String,
  },
  mounted() {},
  computed: {},
  watch: {
    state() {
      this.dialog = true
    },
  },
  methods: {
    close() {
      this.dialog = false
    },
    closeConfirm() {
      this.messageConfirm = false
    },
    openConfirm() {
      this.messageConfirm = true
    },
    confirm() {
      this.$emit('confirm', 'absentFromPresent')
      this.close()
      this.closeConfirm()
    },
  },
  filters: {
    getStatus(status) {
      switch (status) {
        case 'present':
          return 'Có mặt'
        case 'invalidPresent':
          return 'Đi muộn'
        case 'absent':
          return 'Vắng mặt (Chưa xử lý)'
        case 'invalidAbsent':
          return 'Vắng mặt (Không phép)'
        case 'validAbsent':
          return 'Vắng mặt (Có phép)'
        default:
          return '--'
      }
    },
  },
}
</script>

<style></style>
